import { useDarkly } from 'integrations/launchDarkly/legacy/useDarkly';

export function useProjectsFeatureFlags() {
  const { enterpriseProjects } = useDarkly();
  return { isEnabled: enterpriseProjects };
}
